const it = {
  onboarding: {
    countryQuestion: "Capito! 🌍\n\nIn quale paese ti trovi?",
    countryPlaceholder: "In quale paese ti trovi?",
    letsGo: "Andiamo!",
    summaryIntro: "🎉 Fantastico, {name}! È tutto pronto!",
    yourNameLabel: "il tuo nome",
    baseLanguageLabel: "lingua di base",
    goalsHint: "Puoi impostare il tuo obiettivo di vocabolario e la durata del corso in qualsiasi momento dalla pagina Obiettivi.",
    startLearning: "Inizia a imparare il {destLang}!",
  },
  header: {
    learner: "Studente",
    home: "🏠 Home",
    allLessons: "📚 Tutte le lezioni",
    currentLesson: "📖 Lezione corrente",
    flashcards: "🃏 Flashcard",
    progress: "📈 Progressi",
    goals: "🎯 Obiettivi",
    grammarLab: "📘 Grammatica",
    more: "⋯ Altro",
    myVocabulary: "📝 Il Mio Vocabolario",
    listenSpeak: "🎧 Ascolta e Parla",
    signOut: "↩ Esci",
  },
  lab: {
    title: "Laboratorio Ascolta e Parla",
    back: "Indietro",
    intro: "Fai una breve conversazione parlata con Babi su un argomento che hai già studiato.",
    pickTopic: "Scegli un argomento che hai completato",
    noTopics: "Completa prima una lezione, poi torna qui per esercitarti a parlare.",
    level: "Livello {level}",
    talkAbout: "Parla con Babi di «{topic}»",
    speedLabel: "Velocità di Babi",
    speedNormal: "Normale",
    speedSlow: "Lenta",
    speedNote: "La velocità lenta usa più minuti vocali per la stessa risposta.",
    startConversation: "Inizia la conversazione",
    tapToStart: "Tocca il microfono e rispondi a Babi in turco.",
    continueConversation: "Rispondi alla domanda",
    finishSession: "Termina",
    voiceReviewHint: "Controlla cosa hai detto e conferma — oppure riprova.",
    voiceConfirm: "Conferma",
    voiceRedo: "Riprova",
    voiceDenied: "La voce non è disponibile senza accesso al microfono. Tocca l'icona del microfono in qualsiasi momento per riprovare.",
    lowBalanceWarning: "I tuoi minuti vocali per questo ciclo mensile stanno per finire.",
    thinking: "Babi sta pensando…",
    complete: "Sessione completata",
    completeSub: "Bella pratica. Torna quando vuoi per parlare di un altro argomento.",
    another: "Esercitati con un altro argomento",
    done: "Fatto",
    replyError: "Babi non è riuscito a rispondere adesso. Riprova tra un momento.",
    tryAgain: "Riprova",
    eliteUpsellTitle: "Ascolta e Parla è una funzione Elite",
    eliteUpsellBody: "Hai il piano Pro. Passa a Elite nelle Impostazioni per esercitarti a parlare con Babi.",
    listenAgainButton: "Riascolta",
    listenAgainPlaying: "Ferma",
    translateButton: "Traduci",
    translating: "Traduzione…",
    translateFailed: "Traduzione non riuscita — riprova.",
    starsAriaLabel: "{stars} su 3",
    explainButton: "Spiega di più",
    explaining: "Spiegazione in corso…",
    explainFailed: "Spiegazione non riuscita — riprova.",
    recapHeading: "Rapporto della conversazione",
    recapTitle: "Il tuo riepilogo",
    recapAvgStars: "Media di questa sessione",
    recapTurnsCompleted: "{completed} di {total} turni completati",
    recapErrorFree: "{n} turni senza errori",
    recapMistakesByType: "Errori per tipo",
    recapCorrections: "Cosa è stato corretto",
    voiceMinutesTitle: "Minuti vocali",
    voiceMinutesLeft: "{amount} di {total} rimasti in questo ciclo",
    voiceMinutesNone: "Nessun minuto mensile rimasto in questo ciclo",
  },
  dashboard: {
    greeting: "Ciao, {name}! 👋",
    streakMsg: "Serie di {streak} giorni 🔥 — continua così!",
    noStreak: "Inizia la tua prima lezione oggi!",
    streakProtectionDays: "{n} Giorni di Protezione Serie guadagnati 🛡️",
    dayInfo: "Lingua base: {lang} · Giorno {day} di {total}",
    dayStreak: "giorni di fila",
    share: "Condividi",
    wordsLearned: "Parole apprese",
    lessonsDone: "Lezioni completate",
    goalComplete: "Obiettivo raggiunto",
    timeStudied: "Tempo studiato",
    hoursUnit: "Ore",
    paceTitle: "📊 Tracker ritmo giornaliero",
    statusAhead: "🚀 {delta} parole avanti!",
    statusBehind: "⚡ {delta} parole da recuperare",
    statusOnTrack: "✅ Esattamente in linea!",
    paceTarget: "Obiettivo: {wpd} parole/giorno · Oggi: {today} parole",
    paceExpected: "Previsto: {n}",
    paceGoal: "Obiettivo: {n}",
    actionCurrentLesson: "Lezione corrente",
    actionAllLessons: "Tutte le lezioni",
    actionFlashcards: "Flashcard",
    actionProgress: "I miei progressi",
    actionGoals: "I miei obiettivi",
    actionMyVocabulary: "Il Mio Vocabolario",
    actionGrammarLab: "Laboratorio di Grammatica",
    actionListenSpeak: "Laboratorio Ascolta e Parla",
    lessonsSub: "{count} argomenti · {words} parole",
    cardsDue: "{n} carte da ripassare oggi!",
    allCaughtUp: "Tutto aggiornato! 🎉",
    progressSub: "Grafici, precisione, crescita del vocabolario",
    myVocabSub: "Sfoglia tutte le parole che hai imparato",
    listenSpeakSub: "Esercitati a parlare con Babi",
    goalsSub: "{words} parole · {days} giorni",
    apiCost: "💰 Tracker costi API",
    since: "dal {date}",
    resetBtn: "↺ Reimposta",
    totalTokens: "token totali",
    inputTokens: "input",
    outputTokens: "output",
    estCost: "costo stimato",
    apiNote: "claude-sonnet-5 · $3/MTok in · $15/MTok out",
    tipLabel: "Suggerimento:",
    tips: [
      "In turco il verbo viene sempre alla fine della frase — «Ben kahve içiyorum» significa «Io caffè sto-bevendo.» Assorbi semplicemente i modelli!",
      "Il turco usa l'armonia vocalica — i suffissi adattano le loro vocali all'ultima vocale della radice (es. -lar/-ler, -da/-de). Una volta notato, tutto si incastra!",
      "Il turco non ha genere grammaticale. Nessun sostantivo maschile o femminile — una cosa in meno da memorizzare rispetto all'italiano, al francese o allo spagnolo!",
      "I pronomi personali (ben = io, sen = tu) vengono solitamente omessi perché il suffisso verbale indica già chi compie l'azione.",
      "Il turco è foneticamente regolare — ogni lettera si pronuncia sempre allo stesso modo. Quello che leggi è esattamente quello che dici.",
      "La negazione si forma aggiungendo -me/-ma direttamente dopo la radice verbale: gel (vieni) → gelme (non venire), anla (capisci) → anlama.",
      "Il turco usa le posposizioni che vengono DOPO il sostantivo: «İstanbul'da» = «a Istanbul» (Istanbul + suffisso locativo -da).",
      "Il suffisso del plurale segue l'armonia vocalica: -lar dopo vocali posteriori (a, ı, o, u) e -ler dopo vocali anteriori (e, i, ö, ü).",
      "Il suffisso -ıyor/-iyor/-uyor/-üyor indica il presente progressivo. Anlıyorum = Sto capendo (anla + ıyor + um).",
      "I verbi composti turchi combinano un sostantivo con etmek (fare) o olmak (essere): teşekkür etmek (ringraziare), hazır olmak (essere pronto).",
    ],
  },
  lesson: {
    backBtn: "← Indietro",
    topicOf: "Argomento {order} di {total} · {words} parole",
    translating: "Preparazione della lezione…",
    newWords: "✨ Nuove parole ({n})",
    alreadyLearned: "🔄 Già apprese ({n})",
    practiceDialogue: "🎭 Pratica",
    generateDialogue: "🎭 Dammi un dialogo di pratica",
    listenSpeakPractice: "🎧 Esercitati nel Laboratorio Ascolta e Parla",
    generatingDialogue: "Babi sta preparando il dialogo…",
    newDialogue: "↺ Nuovo dialogo",
    lessonSaved: "🎉 Lezione salvata! Aggiunta di {n} nuove flashcard…",
    alreadyTaken: "✅ Lezione già completata",
    markComplete: "✅ Segna lezione come completata e salva le flashcard",
  },
  vocab: {
    structure: "Struttura",
    loadingExample: "Caricamento…",
    limitReached: "↺ Limite raggiunto",
    anotherLeft: "↺ Un altro ({n} rimasto)",
    anotherExample: "↺ Altro esempio",
    analyzing: "Analisi…",
    analyzed: "✓ Analizzato",
    analyzeWord: "🔍 Analizza parola",
    analysisIntro: "Ecco l'analisi grammaticale passo dopo passo:",
    analysisError: "Impossibile caricare l'analisi. Riprova.",
    reportMistake: "🚩 Segnala errore",
    reportWrongMeaning: "Significato della parola errato",
    reportWrongSentence: "Significato della frase errato",
    reportOther: "Altro",
    reportChecking: "Verifica in corso…",
    reportThanks: "✓ Grazie per averci aiutato a migliorare!",
    reportNoIssue: [
      "Non ho trovato alcun problema qui — mi sembra corretto!",
      "Non vedo alcun problema qui — questo sembra corretto.",
      "Dal mio punto di vista, tutto sembra in ordine.",
      "Non sono riuscito a identificare alcun problema; sembra corretto così com'è scritto.",
      "Mi sembra tutto a posto — non ho alcuna preoccupazione.",
      "L'ho controllato e non ho trovato nulla da modificare.",
      "Non mi è saltato all'occhio alcun problema; la traduzione sembra corretta.",
      "Da quello che posso vedere, è tutto corretto.",
      "Non sono riuscito a individuare alcun problema; mi sembra tutto a posto.",
    ],
    reportCheckError: "Ho avuto problemi a completare il controllo. Riprova più tardi.",
    reportOkBtn: "OK, ho capito",
    reportEscalateBtn: "Inoltra a un revisore umano",
    reportEscalatedMsg: "✓ Inviato al nostro team di revisione. Grazie!",
    reportAlreadyFlaggedMsg: "✓ Questo è già stato segnalato al nostro team di revisione. Grazie!",
  },
  allLessons: {
    title: "📚 Tutte le lezioni",
    subtitle: "{count} argomenti · {words} parole",
    searchPlaceholder: "🔍 Cerca argomenti o parole…",
    noResults: "Nessun argomento corrisponde a \"{search}\"",
    overwhelmedBanner: "Hai {n} carte da rivedere. Per favore rivedi i tuoi flashcard prima di iniziare nuove lezioni.",
    overwhelmedLock: "Rivedi prima i flashcard",
    overwhelmedBtn: "Vai ai flashcard →",
  },
  flashcards: {
    title: "Flashcard",
    cardOf: "Carta {current} di {total}",
    tapToReveal: "Tocca per rivelare",
    hearIt: "🔊 Ascolta",
    hearSentence: "🔊 Ascolta la frase.",
    allConsolidated: "Tutto consolidato",
    noDue: "Nessuna carta da ripassare ora.\nLa tua memoria è ben riposata.",
    backToDashboard: "Torna alla dashboard",
    sessionComplete: "Sessione completata",
    memoryRetention: "Efficienza della memoria",
    forgotten: "Dimenticato",
    struggled: "Difficile",
    recalled: "Ricordato",
    effortless: "Facile",
    wordsConsolidated: "{retained} di {total} parole consolidate",
    wordsInProgress: "{retained} di {total} parole in corso",
    saveContinue: "Salva e continua",
    tomorrow: "Domani",
    nDays: "{n} giorni",
    d1Title: "Comprensione",
    d1SubSkill: "Per migliorare le abilità di lettura e ascolto",
    d1Journey: "Le nuove parole iniziano qui il loro viaggio.",
    d1Due: "{n} da rivedere",
    d1Listen: "Ascolta",
    d1ShowWord: "Mostra la parola",
    d2Title: "Produzione",
    d2SubSkill: "Per migliorare le abilità di parlato e scrittura",
    d2WillStart: "Inizierà più tardi",
    d2Empty: "Le parole arrivano qui dopo essere state padroneggiate nel set di comprensione.",
    d2ModalTitle: "Allenamento alla produzione sbloccato!",
    d2ModalBody: "Queste sono parole che già riconosci bene. Ora ti alleniamo a produrle — così passi dal capire il {targetLang} al parlarlo.",
    d2ModalBtn: "Capito",
    leaveConfirmTitle: "Progresso di ripasso non salvato",
    leaveConfirmBody: "Hai ripassato delle carte in questa sessione che non sono ancora state salvate. Se esci ora senza salvare, questo progresso andrà perso.",
    leaveConfirmSave: "Salva ed esci",
    leaveConfirmDiscard: "Scarta ed esci",
    leaveConfirmCancel: "Annulla",
    faq: {
      whyTwoQ: "Perché due mazzi?",
      whyLaterQ: "Perché il set di produzione inizia più tardi?",
      whyReturnQ: "Perché le carte continuano a tornare?",
    },
  },
  grammarLab: {
    title: "📘 Laboratorio di Grammatica",
    subtitle: "{count} argomenti di grammatica da esplorare",
    backBtn: "← Indietro",
    searchPlaceholder: "🔍 Cerca argomenti di grammatica…",
    noResults: "Nessun argomento di grammatica corrisponde a \"{search}\"",
    allCategories: "Tutte le categorie",
    allLevels: "Tutti i livelli",
    notReviewedLabel: "Non consultato",
    reviewedLabel: "Consultato",
    dueBadge: "{n} da ripassare",
    explanationLabel: "Spiegazione",
    seeReference: "(vedi {term})",
    ruleLabel: "Regola",
    formsLabel: "Forme",
    translatingNote: "Traduzione in italiano in corso...",
    practiceBtn: "▶ Esercitati su questo argomento",
    detailedExplanationBtn: "📖 Spiegazione dettagliata",
    practiceTitle: "Esercitazione",
    practiceQuestion: "Come si dice questo in turco?",
    practiceOf: "{current} di {total}",
    practiceCorrectFeedback: "Corretto!",
    practiceIncorrectFeedback: "Non proprio — la risposta era {answer}.",
    practiceNext: "Avanti →",
    practiceDone: "Esercitazione completata",
    practiceScore: "{correct} di {total} corrette",
    practiceNextReview: "Prossimo ripasso tra {days} giorno(i)",
    practiceReset: "Non questa volta — rivedrai questo argomento domani.",
    practiceAgainBtn: "Esercitati di nuovo",
    practiceCloseBtn: "Fatto",
    categories: {
      existential: "Esistenziale",
      noun_suffix: "Suffisso Nominale",
      case_suffix: "Suffisso di Caso",
      verb_conjugation: "Coniugazione Verbale",
      question_particle: "Particella Interrogativa",
      copula: "Copula",
      modal_construction: "Costruzione Modale",
    },
    points: {
      GP0001: { title: "Esistenza e Disponibilità: var / yok", ruleSummary: "[luogo/possessore] + [cosa] + var / yok" },
      GP0002: { title: "Suffisso del Plurale: -ler / -lar", ruleSummary: "sostantivo + -ler (anteriore) / -lar (posteriore)" },
      GP0003: { title: "Caso Locativo: -de / -da / -te / -ta", ruleSummary: "sostantivo + -de/-da; -te/-ta dopo consonante sorda" },
      GP0004: { title: "Caso Dativo: -e / -a", ruleSummary: "sostantivo + -e/-a; si inserisce una -y- di raccordo dopo una vocale" },
      GP0005: { title: "Caso Ablativo: -den / -dan / -ten / -tan", ruleSummary: "sostantivo + -den/-dan; -ten/-tan dopo consonante sorda" },
      GP0006: { title: "Caso Accusativo: -i / -ı / -u / -ü (oggetto diretto definito)", ruleSummary: "sostantivo + -i/-ı/-u/-ü; -y- di raccordo dopo una vocale" },
      GP0007: { title: "Presente Progressivo — Affermativo: -iyor", ruleSummary: "radice verbale + -iyor + desinenza personale" },
      GP0008: { title: "Presente Progressivo — Negativo: -mıyor / -miyor / -muyor / -müyor", ruleSummary: "radice verbale + -mıyor/-miyor/-muyor/-müyor + desinenza personale" },
      GP0009: { title: "Presente Progressivo — Interrogativo: -iyor mu", ruleSummary: "radice + -iyor + mu(+personale); onlar: radice + -iyorlar + mı" },
      GP0010: { title: "Particella Interrogativa Sì/No: mı / mi / mu / mü", ruleSummary: "[parola] + particella separata mı/mi/mu/mü ?" },
      GP0011: { title: "Passato Semplice (Definito): -di / -dı / -du / -dü / -ti / -tı / -tu / -tü", ruleSummary: "radice verbale + -di/-dı/-du/-dü (o -ti/... dopo sorda) + desinenza personale" },
      GP0012: { title: "Desinenze Predicative del Verbo 'Essere' (Presente): -(y)ım, -sin, -ø, -(y)ız, -siniz", ruleSummary: "predicato + -(y)ım / -sin / -ø / -(y)ız / -siniz / (-lar)" },
      GP0013: { title: "Suffissi Possessivi: mio / tuo / suo / nostro / vostro / loro", ruleSummary: "(benim/senin/...) sostantivo + -im/-in/-i/-imiz/-iniz/-leri" },
      GP0014: { title: "Esprimere un Desiderio: -mek / -mak istemek", ruleSummary: "[infinito -mek/-mak] + istemek (coniugato)" },
      GP0015: { title: "Richiesta Cortese / Imperativo 2ª Persona Plurale: -in / -iniz", ruleSummary: "radice verbale + -in/-ın/-un/-ün (cortese) o -iniz (più formale); -y- di raccordo dopo una vocale" },
    },
  },
  placementTest: {
    title: "🎯 Test di livello",
    offerTitle: "Conosci già un po' di turco?",
    offerBody: "Fai un rapido test di livello — circa 20 domande — per trovare il tuo punto di partenza. Imposteremo la tua Lezione attuale di conseguenza, ma tutti gli argomenti restano sempre consultabili.",
    startBtn: "Inizia il test",
    notNowBtn: "Non ora",
    roundLabel: "Round {round} di {totalRounds}",
    questionLabel: "Domanda {n} di {total}",
    wordPrompt: "Cosa significa questa parola?",
    listeningPrompt: "Ascolta e seleziona la parola che senti",
    listeningReplay: "Riascolta",
    preparingRound: "Preparazione delle tue domande…",
    finishBtn: "Vedi il mio risultato",
    resultsTitle: "Il tuo risultato di livello",
    resultsLevel: "Sei stato/a collocato/a al livello {level}",
    resultsBody: "La tua Lezione attuale ora inizia da questo livello. Puoi comunque consultare qualsiasi argomento precedente o successivo in Tutte le lezioni.",
    continueBtn: "Continua",
  },
  goals: {
    title: "🎯 I miei obiettivi",
    displayName: "Nome visualizzato",
    namePlaceholder: "Il tuo nome…",
    vocabTarget: "Obiettivo vocabolario",
    words: "parole",
    minWords: "1.500 min",
    midWords: "2.000",
    maxWords: "3.500 max",
    courseDuration: "Durata corso target",
    months: "Mesi",
    month: "mese",
    monthsPlural: "mesi",
    daysSummary: "= {days} giorni",
    baseLanguage: "Lingua base",
    otherLanguage: "Altre lingue (in arrivo)",
    selectLanguage: "Seleziona una lingua…",
    ok: "OK",
    langNames: {
      English: "Inglese", Farsi: "Persiano", Arabic: "Arabo",
      French: "Francese", German: "Tedesco", Spanish: "Spagnolo",
      Russian: "Russo", Portuguese: "Portoghese", Chinese: "Cinese",
      Turkish: "Turco", Hindi: "Hindi", Italian: "Italiano",
    },
    targetLanguage: "Lingua obiettivo",
    targetLangNames: {
      Turkish: "Turco",
    },
    wordsLbl: "parole",
    wordsPerDay: "parole/giorno",
    daysLbl: "giorni",
    saved: "✅ Obiettivi salvati!",
  },
  progress: {
    title: "📈 I miei progressi",
    memDistTitle: "Distribuzione stati di memoria · {n} carte",
    inAcquisition: "In acquisizione",
    rooted: "Radicato",
    fluent: "Fluente",
    deeplyRetained: "Profondamente radicato",
    acqDesc: "< 3g di stabilità",
    rootedDesc: "3 – 21g di stabilità",
    fluentDesc: "21 – 90g di stabilità",
    retainedDesc: "90g+ di stabilità",
    forecastTitle: "Previsione ripasso — prossimi 15 giorni",
    cardsDue: "Carte da ripassare",
    today: "Oggi",
    tmrw: "Dom.",
    plusDays: "+{n}g",
    todayFull: "Oggi",
    tmrwFull: "Domani",
    plusDaysFull: "+{n} giorni",
    goalProgress: "Progresso complessivo verso l'obiettivo",
    wordsLearned: "{learned} / {target} parole apprese",
    vocabGrowth: "Crescita del vocabolario",
    noChart: "Completa la prima lezione per vedere il grafico! 📚",
    wordsLearnedSeries: "Parole apprese",
    topicRings: "Anelli di memoria per argomento",
    quickStats: "Statistiche rapide",
    dayStreak: "giorni di fila 🔥",
    lessonsDone: "lezioni completate",
    totalStudy: "studio totale",
    avg14Day: "media 14gg",
    minUnit: "min",
    dayLabel: "Giorno {n}",
    cards: "carte",
  },
  myVocab: {
    title: "📝 Il Mio Vocabolario",
    summaryTitle: "{n} Parole Incontrate",
    searchPlaceholder: "🔍 Cerca le tue parole…",
    allStatuses: "Tutti gli stati",
    noResults: "Nessuna parola corrisponde a \"{search}\"",
    noWords: "Completa una lezione per iniziare a costruire il tuo vocabolario! 📚",
    completedTopicsTitle: "Argomenti Completati ({n} di {total})",
    noDate: "—",
  },
  badges: {
    newbie: "Novellino",
    wordExplorer: "Esploratore di Parole",
    wordNerd: "Nerd delle Parole",
    wordWizard: "Mago delle Parole",
    rockstar: "Rockstar",
    expert: "Esperto",
    champion: "Campione",
  },
  memStates: {
    inAcquisition: "In acquisizione",
    rooted: "Radicato",
    fluent: "Fluente",
    deeplyRetained: "Profondamente radicato",
  },
  chat: {
    subtitle: "Il tuo tutor di turco",
    greetWords: ["Ciao", "Salve", "Ehi"],
    greeting: "{greet} {name},\n\nChiedimi qualsiasi cosa sul turco — grammatica, vocabolario, cultura — o su come usare questa app.",
    placeholder: "Domanda sul turco o sull'app…",
    error: "Spiacente, non riesco a connettermi ora. Riprova.",
    escalationFallback: "Mi dispiace, non sono riuscito ad aiutarti completamente con questo. Ho segnalato la cosa al nostro team e riceverai una risposta via email — di solito entro 2 giorni lavorativi. Puoi anche scriverci direttamente all'indirizzo support@speafy.com.",
    welcome: "Ciao, {name}! 👋 Benvenuto/a su Speafy! Sono Babi, e sono qui per due cose: aiutarti a scoprire l'app e rispondere a qualsiasi domanda tu abbia su {targetLanguage}.\n\nInizia con la lezione corrente o scegli un argomento da «Tutte le lezioni». Non dimenticare di segnare ogni lezione come completata quando finisci, poi ripassa le Flashcard.\n\nChiedimi quando vuoi — sull'app o su {targetLanguage}.\n\nBuona fortuna nel tuo percorso di apprendimento! 😊",
    lessonLimit: "Hai già completato {limit} lezioni oggi — ottimo lavoro! 🌟\n\nPer mantenere sostenibile il tuo apprendimento ed evitare di sovraccaricare la coda delle flashcard, c'è un limite giornaliero di {limit} lezioni.\n\nDai al tuo cervello il tempo di consolidare ciò che hai imparato oggi. Che ne dici di una sessione di ripasso delle flashcard?\n\nSarò qui domani per altro! 😊",
    streakDecayed: "Bentornato! 👋 Sei stato via {days} giorno/i. Grazie ai {protection} Giorni di Protezione Serie 🛡️ che avevi guadagnato, la tua serie è scesa solo da {oldStreak} a {newStreak} invece di sparire del tutto. Continuiamo a costruire!",
    streakWiped: "Bentornato! 👋 Sei stato via {days} giorno/i — più dei {protection} Giorni di Protezione Serie 🛡️ che avevi accumulato, quindi la tua serie è ripartita da 1. Ogni serie inizia da qualche parte — ricostruiamola!",
    weeklyRecapFallback: "Ciao! 👋 Volevo portarti il tuo riepilogo settimanale, ma sto avendo problemi a prepararlo proprio ora. Un rapido saluto comunque — sei a una serie di {streak} giorno/i, continua così! 🔥",
    dailyPlanQuestion1: "Ciao! 👋 Quanto tempo hai per studiare oggi?",
    dailyPlanQuestion2: "Ciao! 😊 Ho un piano di studio per te — quanti minuti puoi dedicare oggi?",
    dailyPlanQuestion3: "Pronto/a per il piano di oggi? 🎯 Dimmi solo più o meno quanto tempo hai.",
    dailyPlanClarify: "Scusa, non ho capito bene! Puoi darmi un numero approssimativo, tipo '20' o '30 minuti'?",
    dailyPlanUnreasonable: "Non sembra proprio una sessione di studio tipica! Puoi darmi un numero tra 5 minuti e circa 5 ore?",
    dailyPlanGiveUp: "Nessun problema — quando sei pronto/a, vai su Flashcard o sulla tua Lezione Corrente e inizia! 😊",
    dailyPlanFallback: "Ho preso nota del tempo che hai a disposizione, ma sto avendo problemi a preparare il piano di oggi in questo momento. Nel frattempo, Flashcard è sempre una buona opzione se hai carte in scadenza! 😊",
    sendBtn: "Invia",
    askBabi: "Chiedi a Babi",
    voiceConsentTitle: "Attivare la chat vocale con Babi?",
    voiceConsentBody: "Babi userà il tuo microfono per ascoltarti e il tuo altoparlante per risponderti. Il tuo parlato viene convertito in testo — la registrazione audio in sé non viene mai conservata. Il testo può essere conservato fino a 30 giorni. Consulta la nostra Informativa sulla privacy per i dettagli.",
    voiceConsentPrivacyLink: "Informativa sulla privacy",
    voiceConsentAllow: "Consenti microfono",
    voiceConsentDecline: "Non ora",
    voiceDenied: "La chat vocale non è disponibile senza accesso al microfono. Puoi continuare a chattare scrivendo — tocca l'icona del microfono in qualsiasi momento per riprovare.",
    voiceDeviceInUse: "Il tuo microfono sembra essere in uso altrove — chiudi le altre app che lo stanno usando e riprova.",
    voiceError: "Qualcosa è andato storto con la chat vocale. Riprova.",
    voiceStarting: "Avvio… attendi",
    voiceListening: "Sto ascoltando…",
    voiceProcessing: "Sto capendo…",
    voiceReviewHint: "Tocca per modificare, altrimenti verrà inviato automaticamente tra pochi secondi.",
    voiceSendNow: "Invia ora",
    voiceDiscard: "Ignora",
    voiceEditTranscript: "Modifica ciò che Babi ha sentito",
    voiceBadgeLabel: "Inviato con la voce",
    voiceDidntCatch: "Non ho capito — tocca il microfono per riprovare.",
    voiceSpeaking: "Babi sta parlando…",
    voiceTtsUnavailable: "L'audio non era disponibile per questa risposta — viene mostrato il testo.",
    voiceTtsUnavailableLanguage: "La risposta vocale di Babi non è ancora disponibile in {language}.",
    voiceTapToHear: "Tocca per ascoltare la risposta di Babi",
    voiceNotEntitled: "La chat vocale con Babi è una funzione premium — esegui l'upgrade per usarla.",
    voiceNoBalance: "Hai usato tutti i tuoi minuti vocali per questo ciclo. Si rinnoveranno al prossimo ciclo.",
    voiceOtherTabActive: "La chat vocale è già attiva in un'altra scheda.",
    voiceLowBalanceNudge: "Stanno per finire i minuti vocali di questo ciclo.",
    voiceLowMinutesHeadsUp: "Stanno per finire i minuti vocali di questo ciclo.",
    voiceGetMoreMinutes: "Ottieni altri minuti",
    voiceStopBtn: "Ferma",
    voiceMicButtonLabel: "Chat vocale",
    voiceBannerDismiss: "Ignora",
  },
  settings: {
    title: "Impostazioni",
    accountSection: "Account",
    linkedGoogle: "Collegato con Google",
    emailAccountBadge: "Account e-mail",
    changeNameBtn: "Cambia nome utente",
    nameSaveBtn: "Salva",
    nameCancelBtn: "Annulla",
    nameSaving: "Salvataggio…",
    passwordLabel: "Password",
    passwordSub: "Invia un link di reimpostazione alla tua e-mail",
    passwordSent: "Inviato ✓",
    passwordResetBtn: "Reimposta",
    subscriptionSection: "Abbonamento",
    subscriptionAdminLabel: "Account amministratore",
    subscriptionAdminSub: "Hai accesso completo e permanente a tutte le funzionalità.",
    subscriptionReviewerLabel: "Accesso revisore",
    subscriptionReviewerSub: "Hai accesso gratuito a tutte le funzionalità come revisore dell'app.",
    subscriptionProPlan: "Speafy Pro — {plan}",
    subscriptionElitePlan: "Speafy Elite — {plan}",
    subscriptionPlanAnnual: "Annuale",
    subscriptionPlanMonthly: "Mensile",
    subscriptionRenews: "Si rinnova il {date}",
    subscriptionActive: "Attivo",
    subscriptionManageLink: "Fatturazione e fatture",
    subscriptionCancelLink: "Annulla o metti in pausa l'abbonamento",
    subscriptionPaymentFailedLabel: "L'ultimo pagamento non è riuscito",
    subscriptionPaymentFailedSub: "Pagamento non riuscito il {date}",
    subscriptionPaymentFailedSubNoDate: "Aggiorna il tuo metodo di pagamento per mantenere l'accesso Pro",
    subscriptionUpdatePaymentLink: "Aggiorna metodo di pagamento ↗",
    subscriptionCancelledPending: "Il tuo piano termina il {date} — manterrai l'accesso Pro fino ad allora",
    subscriptionPausedLabel: "Abbonamento in pausa",
    subscriptionPausedSub: "Riprende automaticamente il {date} — ti verrà addebitato l'importo completo di un nuovo periodo a meno che tu non lo riprenda prima",
    subscriptionPausedSubNoDate: "Riprende automaticamente dopo 3 mesi a meno che tu non lo riprenda prima",
    subscriptionResumeBtn: "Riprendi ora",
    subscriptionResuming: "Ripresa in corso…",
    pausePendingLabel: "Pausa programmata",
    pausePendingSub: "Entra in vigore il {date}, alla fine del tuo periodo di fatturazione attuale",
    manageOfferTitle: "Stai pensando di annullare?",
    manageOfferSub: "Metti in pausa invece — manterrai i tuoi progressi fino al {date}, poi l'abbonamento riprenderà automaticamente dopo 3 mesi e ti verrà addebitato l'importo completo di un nuovo periodo, a meno che tu non lo riprenda prima.",
    manageOfferPauseBtn: "Metti in pausa invece",
    manageOfferContinueLink: "Annulla comunque",
    manageOfferDismiss: "Lascia stare",
    pauseOfferLabel: "Hai bisogno di una pausa?",
    pauseOfferSub: "Metti in pausa il tuo abbonamento per 3 mesi invece di cancellarlo — mantieni i tuoi progressi, riprendi quando vuoi.",
    pauseOfferBtn: "Metti in pausa l'abbonamento",
    pauseConfirmP1: "Mettere in pausa il tuo abbonamento Speafy Pro?",
    pauseConfirmC1: "Il tuo periodo di fatturazione attuale continua fino al {date} — mantieni tutto ciò che hai già pagato.",
    pauseConfirmC2: "Durante la pausa, le nuove Lezioni sono bloccate (come un piano gratuito scaduto), ma puoi continuare a ripassare le tue Flashcard esistenti normalmente.",
    pauseConfirmC3: "La pausa dura 3 mesi fissi. Se non la riprendi manualmente prima di allora, il tuo abbonamento riprenderà automaticamente e ti verrà addebitato l'importo completo di un nuovo periodo.",
    pauseConfirmBtn: "Conferma pausa",
    pausing: "Messa in pausa…",
    pauseFailedGeneric: "Qualcosa è andato storto durante la pausa del tuo abbonamento. Riprova o contatta l'assistenza.",
    manageLinkLoading: "Caricamento…",
    manageLinkFailedGeneric: "Impossibile caricare un link di gestione al momento. Riprova.",
    resumeConfirmP1: "Riprendere subito il tuo abbonamento Speafy Pro?",
    resumeConfirmC1: "Ti verrà addebitato immediatamente l'importo completo di un nuovo periodo di fatturazione.",
    resumeConfirmBtn: "Sì, riprendi ora",
    resumeFailedGeneric: "Qualcosa è andato storto durante la ripresa del tuo abbonamento. Riprova o contatta l'assistenza.",
    subscriptionLastCharge: "Ultimo addebito: {amount} il {date} — {status}",
    subscriptionLastChargePaid: "Pagato",
    subscriptionLastChargeFailed: "Non riuscito",
    tierChangePendingLabel: "Cambio piano programmato",
    tierChangePendingToElite: "Passaggio a Elite il {date}",
    tierChangePendingToBasic: "Passaggio a Pro il {date}, alla fine del ciclo di fatturazione attuale",
    tierUpgradeToEliteLink: "Passa a Elite",
    tierDowngradeToBasicLink: "Torna a Pro",
    tierUpgradeConfirmTitle: "Passare a Elite?",
    tierUpgradeConfirmSub: "Oggi ti verrà addebitata la differenza proporzionale e otterrai subito le 3 ore di conversazione vocale di Elite con Babi — {price}/{interval} da ora in poi.",
    tierDowngradeConfirmTitle: "Tornare a Pro?",
    tierDowngradeConfirmSub: "Manterrai Elite fino al {date}, poi passerai a Pro alla prossima data di fatturazione — nessun addebito oggi.",
    tierUpgradeConfirmBtn: "Sì, passa ora",
    tierDowngradeConfirmBtn: "Sì, torna a Pro",
    tierChangeBusy: "Aggiornamento…",
    tierChangeFailedGeneric: "Si è verificato un problema durante la modifica del piano. Riprova o contatta l'assistenza.",
    voiceMinutesLabel: "Minuti vocali ({tier})",
    voiceTierElite: "Elite",
    voiceTierBasic: "Pro",
    voiceTierTrial: "Prova",
    voiceTierAdmin: "Admin",
    voiceTierViewer: "Visualizzatore",
    voiceMinutesUsed: "{used} usati su {limit} in questo ciclo",
    voiceMinutesPurchasedExtra: "In più {extra} acquistati — usati quando finiscono i minuti mensili e non scadono mai",
    yourDataSection: "I Tuoi Dati",
    marketingLabel: "Consenso alle Comunicazioni di Marketing",
    marketingSub: "Aggiornamenti, notifiche e offerte speciali",
    voiceConsentLabel: "Chat Vocale con Babi",
    voiceConsentSub: "Consenti a Babi di ascoltarti e risponderti ad alta voce",
    privacyLegalSection: "Privacy, Termini e Note Legali",
    privacyPolicyLabel: "Informativa sulla Privacy",
    privacyPolicySub: "Come raccogliamo, utilizziamo e proteggiamo i tuoi dati",
    viewLink: "Visualizza",
    termsLabel: "Termini di Servizio",
    termsSub: "Regole e condizioni che disciplinano il tuo utilizzo",
    refundLabel: "Politica di Rimborso",
    refundSub: "Idoneità e modalità di richiesta di un rimborso",
    cookieSettingsLabel: "Impostazioni Cookie",
    cookieSettingsSub: "Gestisci i cookie analitici e funzionali",
    manageLink: "Gestisci",
    privacySection: "Privacy e dati",
    exportLabel: "Esporta i miei dati",
    exportSub: "Scarica un file JSON del tuo profilo, progressi e flashcard",
    exportBtn: "Esporta",
    exportDone: "✓ Scaricato",
    cacheLabel: "Cache locale",
    cacheSub: "I progressi di apprendimento e le frasi di esempio sono salvati nella cache del browser per velocità.",
    cookieLabel: "Impostazioni cookie e privacy",
    cookieSub: "Le preferenze di analisi e cookie sono gestite sul sito web di Speafy",
    privacyLink: "Informativa sulla privacy ↗",
    aboutSection: "Informazioni",
    aiTutorLabel: "Tutor IA",
    aiTutorSub: "Powered by Claude Sonnet — Anthropic",
    algoLabel: "Algoritmo di memoria",
    algoSub: "FSRS v4.5 — Pianificatore di ripetizione spaziata",
    learningSection: "Apprendimento",
    placementTestLabel: "Test di livello",
    placementTestSubNew: "Trova il tuo livello di partenza con un test rapido",
    placementTestSubRetake: "Ultimo livello: {level} · ripetibile in qualsiasi momento",
    placementTestBtnNew: "Fai il test",
    placementTestBtnRetake: "Ripeti il test",
    versionLabel: "Versione",
    appearanceSection: "Aspetto",
    darkModeLabel: "Modalità scura",
    darkModeSub: "Passa a uno schema di colori scuro",
    largeTextLabel: "Testo grande",
    largeTextSub: "Aumenta la dimensione del testo per una lettura più facile",
    babiCheckinsSection: "Check-in di Babi",
    babiDailyNudgeLabel: "Il promemoria quotidiano di Babi",
    babiDailyNudgeSub: "Babi ti chiede quanto tempo hai e ti suggerisce un piano di studio ogni giorno",
    babiWeeklyReportLabel: "Il resoconto settimanale di Babi",
    babiWeeklyReportSub: "Un riepilogo settimanale dei tuoi progressi, una volta a settimana",
    dangerSection: "Zona di pericolo",
    resetLabel: "Reimposta tutti i progressi",
    resetSub: "Cancella la tua serie, le flashcard e la cronologia delle lezioni. Non può essere annullato.",
    resetBtn: "Reimposta",
    resetConfirmP1: "Reimpostare tutti i progressi? Questo eliminerà definitivamente:",
    resetConfirmC1: "Tutte le {n} flashcard e i loro dati di memoria",
    resetConfirmC2: "La tua serie ({n} giorni) e la cronologia di studio",
    resetConfirmC3: "Tutti i record di lezioni completate, in ogni lingua che stai imparando",
    resetConfirmC4: "I tuoi progressi di ripasso nel Laboratorio di Grammatica",
    resetConfirmP2: "Il tuo account, nome e impostazioni della lingua verranno mantenuti.",
    resetConfirmBtn: "Sì, reimposta tutto",
    resetting: "Reimpostazione…",
    resetDone: "✅ Progressi reimpostati! Stai ricominciando da capo.",
    deleteLabel: "Elimina account",
    deleteSub: "Elimina definitivamente il tuo account e tutti i dati. Non può essere annullato.",
    deleteBtn: "Elimina account",
    deleteConfirmP1: "Eliminare definitivamente il tuo account Speafy? Questo eliminerà immediatamente e irreversibilmente:",
    deleteConfirmC1: "Il tuo profilo (nome, lingua, obiettivi)",
    deleteConfirmC2: "Tutte le {n} flashcard e i dati di memoria",
    deleteConfirmC3: "La tua cronologia completa di apprendimento e serie",
    deleteConfirmC4: "Il tuo account di autenticazione Firebase",
    deleteConfirmPrompt: "Digita DELETE (in maiuscolo) per confermare:",
    deleteConfirmBtn: "Elimina definitivamente il mio account",
    deleting: "Eliminazione…",
    cancelBtn: "Annulla",
  },
  trial: {
    daysLeftBadge: "⏱ {n} giorni rimasti",
    expiredBadge: "Prova terminata · Aggiorna ↑",
    pausedBadge: "⏸ In pausa",
    proBadge: "✦ Piano Pro",
    eliteBadge: "✦ Piano Elite",
  },
  paywall: {
    back: "← Indietro",
    title: "Passa a Speafy Pro",
    subTrialExpired: "Il tuo periodo di prova è terminato. Aggiorna per continuare ad imparare.",
    subDefault: "Sblocca tutte le lezioni e la revisione delle flashcard.",
    features: [
      "Tutte le {count} lezioni completamente sbloccate",
      "Chat illimitata con Babi, il tuo tutor AI",
      "Revisione flashcard FSRS intelligente",
      "Monitoraggio progressi e analisi della memoria",
      "Audio nativo per ogni parola",
      "Dialoghi di pratica",
      "Interfaccia multilingua",
    ],
    tierPro: "Pro",
    tierElite: "Elite",
    eliteFeatures: [
      "Tutto quello che c'è in Speafy Pro",
      "Laboratorio Ascolta e Parla — pratica di conversazione guidata con Babi",
      "3 ore di conversazione vocale con Babi ogni mese",
      "Acquista minuti vocali extra in qualsiasi momento — $3/ora",
    ],
    billingMonthly: "Mensile",
    billingYearly: "Annuale",
    saveBadge: "Risparmia 25%",
    pricePerMonth: "/mese",
    priceBilledYearly: "fatturato annualmente",
    cta: "Inizia Speafy Pro →",
    ctaElite: "Inizia Speafy Elite →",
    fine: "Annulla in qualsiasi momento · Pagamento sicuro via Paddle",
    bannerExpired: "Il tuo periodo di prova gratuita è terminato.",
    bannerActive: "Prova gratuita — {n} giorni rimasti.",
    bannerBtn: "Aggiorna ↑",
    settingsFreePlan: "Piano Gratuito",
    pausedTitle: "Il tuo abbonamento è in pausa",
    pausedSub: "Riprendi il tuo abbonamento in Impostazioni per sbloccare di nuovo le nuove lezioni.",
    pausedGoToSettingsBtn: "Vai a Impostazioni",
    alreadyProTitle: "Sei già Pro!",
    alreadyProSub: "Il tuo abbonamento è attivo — non serve acquistare di nuovo.",
    alreadyProGoHomeBtn: "Vai alla Home",
    settingsTrialRemaining: "Prova — {n} giorni rimasti",
    settingsTrialEnded: "Prova terminata — aggiorna per sbloccare tutte le lezioni",
    settingsFreeForever: "Riprendi da dove avevi lasciato — aggiorna per sbloccare tutte le lezioni",
    settingsUpgradeBtn: "Aggiorna",
  },
  authAction: {
    verifyingTitle: "Verifica della tua email in corso…",
    verifiedTitle: "La tua email è stata verificata!",
    verifiedBody: "Tutto pronto. Continua su Speafy per proseguire l'apprendimento.",
    continueBtn: "Continua su Speafy →",
    verifyErrorTitle: "Questo link è scaduto",
    verifyErrorBody: "Questo link di verifica non è più valido. Accedi e te ne invieremo uno nuovo.",
    resendBtn: "Invia di nuovo l'email di verifica",
    resendSent: "Inviata ✓",
    resendError: "Impossibile inviarla di nuovo. Riprova tra un momento.",
    signInBtn: "Accedi",
    verifyingReset: "Verifica del link in corso…",
    resetTitle: "Reimposta la tua password",
    resetBodyFor: "Scegli una nuova password per {email}",
    newPasswordPh: "Nuova password",
    confirmPasswordPh: "Conferma la nuova password",
    resetSubmitBtn: "Reimposta password",
    resettingBtn: "Reimpostazione…",
    resetSuccessTitle: "Password aggiornata!",
    resetSuccessBody: "La tua password è stata modificata. Accedi con la tua nuova password.",
    resetErrorTitle: "Questo link è scaduto",
    resetErrorBody: "Questo link per reimpostare la password non è più valido. Richiedine uno nuovo dalla schermata di accesso.",
    passwordMismatch: "Le password non coincidono.",
    passwordTooShort: "La password deve contenere almeno 6 caratteri.",
    genericError: "Qualcosa è andato storto. Riprova.",
    invalidTitle: "Questo link non è valido o è scaduto",
    invalidBody: "Il link che hai seguito non è più valido. Torna su Speafy e riprova.",
    backToSignIn: "Torna al login",
  },

  teacherDash: {
    link: "Dashboard insegnante",
    title: "Dashboard insegnante",
    backHome: "Torna alla home",
    studentBadge: "Il tuo insegnante: {name}",
    intro: "Tutto ciò che ti serve per portare i tuoi studenti su Speafy e seguire i loro progressi.",
    referralTitle: "Il tuo link di invito",
    referralBody: "Condividi questo link con i tuoi studenti. Chiunque si registri tramite questo link viene collegato a te come insegnante.",
    copy: "Copia link",
    copied: "Copiato",
    studentsTitle: "I tuoi studenti",
    studentsLoading: "Caricamento dei tuoi studenti…",
    studentsError: "Non è stato possibile caricare i tuoi studenti in questo momento.",
    retry: "Riprova",
    studentsEmpty: "Ancora nessuno studente. Condividi il tuo link di invito — gli studenti che si iscrivono tramite il link compariranno qui.",
    colName: "Studente",
    colJoined: "Iscritto il",
    colStatus: "Abbonamento",
    colCommission: "Commissione maturata",
    colGrammar: "Focus grammaticale",
    statusActive: "Attivo",
    statusTrial: "Prova",
    statusNone: "Nessun abbonamento",
    commissionNote: "Questo è ciò che hai guadagnato da ciascuno studente in totale. Il tuo saldo disponibile per il pagamento è mostrato di seguito.",
    commissionCapReached: "Periodo di 12 mesi terminato",
    grammarNote: "I dati sugli errori grammaticali vengono mostrati solo per gli studenti con un abbonamento attivo.",
    studentUnnamed: "Studente",
    curriculumTitle: "Riferimento del programma",
    curriculumBody: "Sfoglia tutti gli argomenti e le parole che i tuoi studenti imparano, in ordine.",
    curriculumLink: "Apri il riferimento del programma",
    profileTitle: "Il tuo profilo da insegnante",
    profileBody: "Ecco come apparirai nella directory degli insegnanti di Speafy al momento del lancio.",
    profileBio: "Breve bio",
    profileBioPh: "Una o due frasi su di te e su come insegni.",
    profilePhoto: "Foto",
    photoChoose: "Scegli foto",
    photoUploading: "Caricamento…",
    photoRemove: "Rimuovi",
    photoHint: "PNG o JPG, fino a 200 KB.",
    photoTypeErr: "Scegli un'immagine PNG o JPG.",
    photoSizeErr: "Questa immagine supera i 200 KB — scegline una più piccola.",
    photoUploadErr: "Caricamento non riuscito. Riprova.",
    profileLink: "Sito web personale o link a un social",
    profileLinkPh: "www.esempio.com",
    profileLanguages: "Lingue che insegno",
    profileLanguagesHint: "Scegli le lingue che insegni. Se ne sbloccheranno altre man mano che Speafy le aggiunge come lingue del corso.",
    profileLanguagesSoon: "In arrivo",
    save: "Salva",
    saving: "Salvataggio…",
    saved: "Salvato",
    urlError: "Non sembra un indirizzo web. Controllalo o lascia il campo vuoto.",
    termsStatusAccepted: "Termini per i docenti partner — Accettati il {date}",
    termsStatusPending: "Termini per i docenti partner — Non ancora accettati",
    termsVersionLabel: "Versione {version}",
    termsView: "Vedi i Termini accettati",
    payoutTitle: "Pagamento",
    payoutLoading: "Caricamento dello stato del pagamento…",
    payoutError: "Non siamo riusciti a caricare lo stato del tuo pagamento in questo momento.",
    payoutBalance: "Il tuo saldo attuale: {balance}",
    payoutNotEligible: "Potrai richiedere un pagamento quando il tuo saldo raggiungerà {threshold}.",
    payoutAlreadyRequested: "Pagamento richiesto — ti contatteremo.",
    requestPayoutBtn: "Richiedi pagamento",
    payoutRequestFailed: "Si è verificato un errore durante l'invio della richiesta. Riprova.",
    payoutConfirmTitle: "Richiedere un pagamento?",
    payoutConfirmBody: "Al momento hai {balance} disponibili da richiedere.\n\nQuesto avvia un processo di pagamento manuale — nessun importo viene trasferito automaticamente. Esamineremo la tua richiesta e ti risponderemo via email.",
    payoutConfirmBtn: "Richiedi pagamento",
    payoutConfirmCancel: "Annulla",
  },

  teacherTerms: {
    screenTitle: "Termini per i docenti partner",
    contents: "Indice",
    lastUpdatedLabel: "Ultimo aggiornamento",
    effectiveLabel: "Data di entrata in vigore",
    bannerTitle: "Azione necessaria",
    bannerBody: "Leggi e accetta i Termini per i docenti partner per continuare come partner.",
    bannerCta: "Leggi e accetta",
    acceptedOn: "Hai accettato questi Termini il {date}.",
    acceptedVersion: "Versione accettata: {version}",
    accepting: "Registrazione della tua accettazione…",
    acceptError: "Non è stato possibile registrare la tua accettazione in questo momento. Riprova.",
    draftNotice: "Questi Termini non sono ancora definitivi. Potrai accettarli una volta stabilita la data di entrata in vigore.",
  },
};

export default it;
